module.exports = __webpack_public_path__ + "static/mixed-berry-339c688f48c5b6679efb0d082b88a8a0.png";